//MOVIE
export const GET_LIST_MOVIES = 'movie/GET_LIST_MOVIES';

//THEATER
export const GET_LIST_THEATERGROUP = 'theater/GET_LIST_THEATERGROUP';
export const POST_THEATERGROUP_CHOOSED = 'theater/POST_THEATERGROUP_CHOOSED';
export const GET_LIST_THEATER_BY_ID = 'theater/GET_LIST_THEATER_BY_ID';
export const POST_ID_THEATER_CHOOSE = 'theater/POST_ID_THEATER_CHOOSE';
export const GET_LIST_MOVIES_IN_THEATER = 'theater/GET_LIST_MOVIES_IN_THEATER';

//USER
export const SET_TOKEN_USER = 'user/SET_TOKEN_USER';

//CHECKOUT
export const POST_LIST_SEATS = 'checkout/POST_LIST_SEATS';
export const POST_SEAT_CHOICED = 'checkout/POST_SEAT_CHOICED';
export const CLEAR_LIST_CHOICED = 'checkout/CLEAR_LIST_CHOICED';
export const CLEAR_LIST_CHOICED_FIRST = 'checkout/CLEAR_LIST_CHOICED_FIRST';
